import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/descuentos-devoluciones-ahorros-detalles';

/**
 * GET Retiros De Ahorros Detalles
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRetirosDeAhorrosDetalle = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Retiro De Ahorro Detalle
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getRetiroDeAhorroDetalle = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Retiro De Ahorro Detalle
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postRetiroDeAhorroDetalle = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Retiro De Ahorro Detalle
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchRetiroDeAhorroDetalle = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Retiro De Ahorro Detalle
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteRetiroDeAhorroDetalle = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
